import axios from "axios";
import { useCallback } from "react";

const API = process.env.REACT_APP_API_URL;

export function useMissionGuide({ code, playerId, stage }) {
  const missionUnlock = useCallback(async ({ key, text }) => {
    try {
      await axios.post(
        `${API}/api/sessions/${code}/mission-guide/unlock`,
        {
          playerId: Number(playerId),
          stage: Number(stage),
          key,
          text,
        }
      );
    } catch (e) {
      console.warn(
        "missionUnlock failed",
        e.response?.data || e.message
      );
    }
  }, [code, playerId, stage]);

  const missionResolve = useCallback(async ({ key }) => {
    try {
      await axios.post(
        `${API}/api/sessions/${code}/mission-guide/resolve`,
        {
          playerId: Number(playerId),
          key,
        }
      );
    } catch (e) {
      console.warn(
        "missionResolve failed",
        e.response?.data || e.message
      );
    }
  }, [code, playerId]);

  return {
    missionUnlock,
    missionResolve,
  };
}